export default __webpack_public_path__ + "static/media/Eina01-Light.89a3530e.ttf";